import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=4e0a98d8&scoped=true"
import script from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=4e0a98d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a98d8",
  null
  
)

export default component.exports